import { takeEvery, put, call, all, fork } from "redux-saga/effects"
import toastr from "toastr"
import { getPlatformUsers as getPlatformUsersBackend, restrictPlatformUser as restrictBackend, unrestrictPlatformUser as unrestrictBackend } from "../../helpers/backend_helper"
import { GET_PLATFORM_USERS, getPlatformUsers, getPlatformUsersSuccess, RESTRICT_PLATFORM_USER, UNRESTRICT_PLATFORM_USER } from "./actions"

const MSG_GENERIC_ERROR = "Se ha producido un error, intenta nuevamente o contacta con el administrador"

// Errores 422 de sendError llegan con message en response.data
const errorMessage = error => error?.response?.data?.message || MSG_GENERIC_ERROR

function* fetchPlatformUsers() {
  try {
    const response = yield call(getPlatformUsersBackend)
    if (response.success) {
      yield put(getPlatformUsersSuccess(response.data))
    } else {
      toastr.error(response.message)
    }
  } catch (error) {
    console.log(error)
    toastr.error(errorMessage(error))
  }
}

function* onRestrictUser({ payload }) {
  try {
    const response = yield call(restrictBackend, payload)
    if (response.success) {
      toastr.success(response.message)
      yield put(getPlatformUsers())
    } else {
      toastr.error(response.message)
    }
  } catch (error) {
    console.log(error)
    toastr.error(errorMessage(error))
  }
}

function* onUnrestrictUser({ payload }) {
  try {
    const response = yield call(unrestrictBackend, payload)
    if (response.success) {
      toastr.success(response.message)
      yield put(getPlatformUsers())
    } else {
      toastr.error(response.message)
    }
  } catch (error) {
    console.log(error)
    toastr.error(errorMessage(error))
  }
}

export function* watchPlatformAdminSaga() {
  yield takeEvery(GET_PLATFORM_USERS, fetchPlatformUsers)
  yield takeEvery(RESTRICT_PLATFORM_USER, onRestrictUser)
  yield takeEvery(UNRESTRICT_PLATFORM_USER, onUnrestrictUser)
}

function* platformAdminSaga() {
  yield all([fork(watchPlatformAdminSaga)])
}

export default platformAdminSaga;
